import React from 'react';
import DefaultSummary from './DefaultSummary.js';
const NoteSummary = (props) => React.createElement(DefaultSummary, { ...props });
export default NoteSummary;
//# sourceMappingURL=NoteSummary.js.map